<template>
	<div class="select-tabs">
		<p class="select-tabs.item select-tabs.sort">
			<a href="javascript:;" @click="timeSort" v-show="isSelect">
				<span>入驻时间</span>
				<span v-if="!isSwicthTime"><img src="../assets/trademarks/sort.png"></span>
				<span v-else>
					<img src="../assets/trademarks/up-sort.png" v-show="isTimeUp">
					<img src="../assets/trademarks/down-sort.png" v-show="!isTimeUp">
				</span>
			</a>
			<a href="javascript:;" @click="priceSort" v-show="isSelect">
				<span>价格排序</span>

				<span v-if="!isSwicthPrice"><img src="../assets/trademarks/sort.png"></span>
				<span v-else>
					<img src="../assets/trademarks/up-sort.png" v-show="isPriceUp">
					<img src="../assets/trademarks/down-sort.png" v-show="!isPriceUp">
				</span>
			</a>
		</p>
		<div class="select-tabs.item select-tabs.search">
			<div>
				<el-input type="text" :placeholder="placeholder" v-model="searchKey" clearable @clear="searchKeyResult"></el-input>
				<span @click="searchKeyResult"><img src="../assets/trademarks/search.png" alt=""></span>
			</div>
			<p>共 <span>{{selectTabs.account}}</span> 个{{selectTabs.type}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		// props: ['selectTabs','isSelect','placeholder'],
		props:{
			selectTabs:{
				string: Array,
				default:(()=>{
					return []
				})
			},
			isSelect:{
				string: Boolean,
				default: true
			},
			placeholder:{
				string: String,
				default: '在结果中搜索'
			}
		},
		data() {
			return {
				searchKey: '',
				isPriceUp: false,
				isSwicthPrice: false,
				isSwicthTime: false,
				isTimeUp: false
			}
		},
		methods: {
			searchKeyResult() {
				this.$emit('searchEvent', this.searchKey)
			},
			timeSort() {
				this.isSwicthTime = true
				this.isSwicthPrice = false
				this.isTimeUp = !this.isTimeUp
				if (this.isTimeUp) {
					this.$emit('timeSortEvent', {
						timeType: 1,
						priceType: ''
					})
				} else {
					this.$emit('timeSortEvent', {
						timeType: 2,
						priceType: ''
					})
				}

			},
			priceSort() {
				this.isSwicthPrice = true
				this.isSwicthTime = false
				this.isPriceUp = !this.isPriceUp
				if (this.isPriceUp) {
					this.$emit('priceSortEvent',{
						timeType: '',
						priceType: 1
					})
				} else {
					this.$emit('priceSortEvent', {
						timeType: '',
						priceType: 2
					})
				}
			}
		},
	}
</script>

<style lang="scss">
	@include component(select-tabs) {
		width: 100%;
		height: 50px;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		color: #333;
		background: #fff;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #333;
		font-size: 16px;

		@include part(item) {
			width: 50%;
			height: 100%;
			display: flex;
			align-items: center;

		}

		@include part(sort) {
			justify-content: flex-start;

			a {
				display: flex;
				padding: 0 30px;
				border-right: 1px solid #E2E2E2;
				color: #333;
				font-size: 16px;

				&:not(:nth-child(1)) {
					border-right: 0;
				}

				span {
					display: inline-block;

					&:nth-child(2) {
						padding-left: 10px;
					}
				}
			}
		}

		@include part(search) {
			justify-content: flex-end;
			padding-right: 18px;

			div {
				width: 235px;
				height: 34px;
				// border: 1px solid rgba(226, 226, 226, 1);
				border-radius: 5px;
				overflow: hidden;
				position: relative;
				margin-right: 30px;

				.el-input {
					// display: inline-block;
					// width: 100%;
					height: 100%;
					// position: absolute;
					// top: 0;
					// left: 0;
					border: none;
					outline: none;
					// padding-left: 15px;
					.el-input__inner{
						height: 100%;
					}
					span{
						line-height: 34px;
						margin-top: -2px;
						margin-right: 2px;
					}
				}

				span {
					display: flex;
					align-items: center;
					position: absolute;
					height: 100%;
					top: 0;
					right: 11px;

					img {
						display: block;
						width: 100%;
					}

					cursor: pointer;
				}
			}

			p {
				span {
					color: #F47227;
				}
			}
		}
	}
</style>
